import type { IControl } from "maplibre-gl";
import { mapControlButton } from "../map-embed-controls.ts";
import { t } from "../i18n/index.ts";

/** Crosshair outline — matches other home map control icons (stroke currentColor). */
export const MY_LOCATION_ICON_SVG =
  '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="3.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="M12 3v3M12 18v3M3 12h3M18 12h3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

export class MyLocationControl implements IControl {
  private readonly container = document.createElement("div");
  private readonly button: HTMLButtonElement;

  constructor(onPress: () => void) {
    this.container.className = "maplibregl-ctrl";
    this.button = mapControlButton(
      "route-map-my-location map-view-my-location",
      t("rt.map.myLocation"),
      MY_LOCATION_ICON_SVG,
      onPress,
    );
    this.container.append(this.button);
  }

  onAdd(): HTMLElement {
    return this.container;
  }

  onRemove(): void {
    this.container.remove();
  }

  setBusy(busy: boolean): void {
    this.button.disabled = busy;
    this.button.setAttribute("aria-busy", busy ? "true" : "false");
  }

  setShown(shown: boolean): void {
    this.container.hidden = !shown;
  }
}
